import DepositWithdrawSection from '../components/sections/deposit-withdraw/depositWithdraw.section';

export default function DepositPage() {
  return <DepositWithdrawSection method={0} />;
}
